<template>
  <Events
    link="analytics"
    :items="items" />
</template>

<script>
import Events from '@/components/Events.vue'

export default {
  components: {
    Events
  },
  computed: {
    items: function () {
      return [
        {
          title: 'Add to cart',
          key: 'add_to_cart.add_to_cart',
          link: 'amp_products'
        },
        {
          title: 'Quick buy',
          key: 'quick_buy.quick_buy',
          link: 'amp_products'
        },
        {
          title: 'Review widget',
          key: 'load_reviews.*',
          link: 'amp_reviews'
        }
      ]
    }
  }
}
</script>
